import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { notificationsBlockWidget } from './widgets';

const scenario = createScenario((ctx) => {
    ctx.addWidget({
        widget: notificationsBlockWidget,
        component: lazy(() => import('./components/Notifications/Notifications')),
    });
});

export default scenario;
